import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

var Fortress = window.cccisd.fortress;
export default class Component extends React.Component {
    static propTypes = {
        className: PropTypes.string,
    };

    static defaultProps = {
        className: 'container-fluid',
    };

    render() {
        let showTheseProfileDataFields = {
            groupingAdmin: ['idNumber'],
            manager: ['idNumber'],
            siteAdmin: ['idNumber'],
        };

        return (
            <Header
                containerClassName={this.props.className}
                wrapperClassName={style.wrapper}
                logoClassName={style.logo}
                showAlertAction={false}
                showHomeAction={false}
                showAdminAction={Fortress.isSuperUser()}
                isDarkPrimaryNav
                showTheseProfileDataFields={showTheseProfileDataFields}
                secondaryNavLinks="mainNav"
            />
        );
    }
}
